import type { HotEvent } from '@/mocks/events';

export function statusTone(status: HotEvent['status']) {
  switch (status) {
    case '发酵中':
      return { dot: 'bg-accent-500', text: 'text-accent-800', badge: 'bg-accent-100 text-accent-900 border-accent-200' };
    case '持续更新':
      return { dot: 'bg-primary-500', text: 'text-primary-800', badge: 'bg-primary-100 text-primary-900 border-primary-200' };
    default:
      return { dot: 'bg-secondary-400', text: 'text-secondary-700', badge: 'bg-secondary-100 text-secondary-800 border-secondary-200' };
  }
}

export function StatusBadge({ status }: { status: HotEvent['status'] }) {
  const tone = statusTone(status);
  const live = status !== '已告一段落';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${tone.badge}`}
    >
      {live && <span className={`h-1.5 w-1.5 rounded-full ${tone.dot} ${status === '发酵中' ? 'pulse-dot' : ''}`} />}
      <span className="tabular-nums">{status}</span>
    </span>
  );
}

export function CategoryTag({ category, onClick }: { category: string; onClick?: () => void }) {
  return (
    <span
      onClick={onClick}
      className={`inline-flex cursor-pointer items-center gap-1 rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800 transition-colors hover:bg-primary-100 hover:text-primary-800 whitespace-nowrap ${onClick ? '' : 'pointer-events-none'}`}
    >
      <i className="ri-price-tag-3-line text-[11px]" />
      {category}
    </span>
  );
}

export function heatLevel(heat: number) {
  if (heat >= 90) return '高热';
  if (heat >= 80) return '上升';
  return '平稳';
}

export function formatZhDate(date: string) {
  const d = new Date(date);
  return `${d.getMonth() + 1}月${d.getDate()}日`;
}